<template>
  <b-row>
    <b-col cols="12" v-if="can('read/laporan-sppd')">
      <b-card title="Laporan SPPD">
        <b-row class="pb-2">
          <b-col class="mb-1">
            <b-button
              v-if="can('filter/laporan-sppd')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="ml-0"
              @click="show=true"
            >
              Filter
            </b-button>
            <b-button
              v-if="can('print/laporan-sppd')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="ml-2"
              @click="exportData()"
              :disabled="totalRows === 0 && isTriger === false"
            >
              Export Data
            </b-button>
          </b-col>

          <b-col md="4" xs="12">
            <b-form @submit.prevent="handleSearch">
              <b-input-group size="8">
                <b-form-input
                  id="filterInput"
                  v-model="search"
                  type="search"
                  :placeholder="'Cari disini...'"
                />
                <b-input-group-append>
                  <b-button :disabled="!search" @click="search = ''">
                    Hapus
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
        </b-row>
      
        <b-table
          striped
          hover
          responsive
          show-empty
          class="position-relative"
          primary-key="email"
          :per-page="perPage"
          :current-page="currentPage"
          :items="getItems"
          :fields="regionalUser == 99 ? fields : fieldsRegional"
          :busy="busy"
          ref="tableFe"
        >
          <template #table-busy>
            <div class="text-center my-3">
              <!-- <b-spinner small type="grow" label="Loading..."></b-spinner> -->
              <div>Loading data, please wait...</div>
            </div>
          </template>
          <template #empty>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>
          <template #emptyfiltered>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>
          
          <template #cell(no)="data">
            <span v-if="!data.item.isTotal">
              {{ (currentPage - 1) * perPage + (data.index + 1) }}
            </span>
          </template>

          <template #cell(name)="data">
            <span v-if="!data.item.isTotal">
              {{ data.item.nippos }} / {{ data.item.name }}
            </span>
          </template>

          <template #cell(departure_date)="data">
            {{ data.item.departure_date | moment('DD-MM-YYYY') }}
          </template>

          <template #cell(return_date)="data">
            {{ data.item.return_date | moment('DD-MM-YYYY') }}
          </template>

          <template #cell(total_days)="data">
            <span v-if="!data.item.isTotal">
              {{ data.item.total_days + ' hari' }}
            </span>
          </template>

          <template #cell(sppd_number)="data">
            <span v-if="!data.item.isTotal">
              {{ data.item.sppd_number }}
            </span>
            <span v-else class="font-weight-bold d-block">Total Page ke {{ currentPage }}</span>
          </template>

          <template #cell(name_regional)="data">
            <span v-if="!data.item.isTotal">
              {{ data.item.name_regional }}
            </span>
          </template>

          <template #cell(mitra_accomodation_name)="data">
            <span v-if="!data.item.isTotal">
            {{ data.item.mitra_accomodation_name == null ? "-" : data.item.mitra_accomodation_name }}
            </span>
          </template>

          <template #cell(mitra_transportation_name)="data">
            <span v-if="!data.item.isTotal">
            {{ data.item.mitra_transportation_name == null ? "-" : data.item.mitra_transportation_name }}
            </span>
          </template>

          <template #cell(daily_trip_money)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.daily_trip_money | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalUangHArian | currency }}</span>
          </template>

          <template #cell(total_pengeluaran_rill)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.total_pengeluaran_rill | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalPengeluaranRiil | currency }}</span>
          </template>

          <template #cell(total_transportation)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.total_transportation | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalTransportasi | currency }}</span>
          </template>

          <template #cell(total_accomodation)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ data.item.total_accomodation | currency }}
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalAkomodasi | currency }}</span>
          </template>

          <template #cell(total_jumlah)="data">
              <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
                  <!-- {{ (data.item.pph21 === '-') ? '-' : ((data.item.pph21 == null) ? (data.item.total * 0.05) : data.item.pph21) | currency }} -->
                  {{ data.item.total | currency }}
              </span>
              <span v-else class="font-weight-bold text-right d-block">{{ totalJumlah | currency }}</span>
          </template>

          <template #cell(pph21)="data">
              <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
                  <!-- {{ (data.item.pph21 === '-') ? '-' : ((data.item.pph21 == null) ? (data.item.total * 0.05) : data.item.pph21) | currency }} -->
                  {{ data.item.pph21 ? 'Rp ' + Number(data.item.pph21).toLocaleString('id-ID') : '-' }}
              </span>
              <span v-else class="font-weight-bold text-right d-block">{{ totalPPH21 | currency }}</span>
          </template>


          <template #cell(total)="data">
            <span v-if="!data.item.isTotal" class="text-capitalize d-block" style="text-align: end;">
              {{ ((data.item.pph21 == null) ? (data.item.total) : (data.item.pph21 + data.item.total)) | currency }}
                <!-- {{ data.item.total | currency }} -->
            </span>
            <span v-else class="font-weight-bold text-right d-block">{{ totalAll | currency }}</span>
          </template>

          <!-- A virtual column -->
          <template #cell(Aksi)="data">
            <div v-if="!data.item.isTotal" style="min-width: 270px">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                v-b-popover.hover.bottom="'Detail'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                v-b-popover.hover.bottom="'Approve'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                v-b-popover.hover.bottom="'Ubah'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
              >
                <feather-icon icon="EditIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                v-b-popover.hover.bottom="'Hapus'"
                size="sm"
                class="btn-icon float-sm-left mr-1"
                @click="confirmText(data.item.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </div>
          </template>
        </b-table>

        <span v-if="totalRows == 1" style="margin: 1rem"></span>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
                id="perPageSelect"
                v-model="perPage"
                @change="changePerPage()"
                size="sm"
                inline
                :options="pageOptions"
            />
          </b-form-group>

          <div>
            Menampilkan {{ from }} hingga {{ to }} dari {{ totalRows }} entri
          </div>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

            <!-- Modal -->
            <b-modal
              id="modal-filter"
              v-model="show"
              title="Filter"
              size="md"
              cancel-variant="outline-secondary"
            >
            <div class="hidden-scrollbar box-filter-laporan-sppd">
              <div class='inner'>
                <b-form @submit.prevent="handleSubmit(filter)">
                  <b-row class="mb-1">
                    <b-col md="12">
                      <label>Sumber Anggaran</label>
                      <multiselect
                        placeholder="Sumber Anggaran"
                        v-model="selectedProject"
                        label="text"
                        track-by="value"
                        :options="selectProjectOption"
                      ></multiselect>
                    </b-col>
                    <b-col md="6" class="mt-1" v-if="role_name == 'Admin Nasional'">
                      <label>Sub Direktorat</label>
                      <multiselect
                        placeholder="Cari Sub Direktorat"
                        v-model="subdirData"
                        label="namabagian_child"
                        track-by="kodebagian_child"
                        :options="subdirLists"
                        @input="changeSubdir"
                      ></multiselect>
                    </b-col>
                    <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                      <label>REGIONAL</label>
                      <multiselect 
                        v-model="selectRegional"
                        name="idwilayah"
                        label="nmwilayah"
                        track-by="idwilayah" 
                        placeholder="Cari Regional"
                        :options="regional"
                        class="single-select filter-laporan-sppd"
                        :max-height="600"
                        :disabled="true"
                        @input="selectedUPT(selectRegional.idwilayah, selectRegional.nopen)">
                        <span slot="noResult">Maaf UPT tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                      <label>KCU</label>
                      <multiselect 
                        v-model="selectKCU"
                        name="nopend"
                        label="namaktr"
                        track-by="nopend" 
                        placeholder="Cari KCU"
                        :options="kcu"
                        :disabled="isKCUDisable"
                        class="single-select filter-laporan-sppd"
                        :max-height="600"
                        @input="onKCUChange">
                        <span slot="noResult">Maaf KCU tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                      <label>KC</label>
                      <multiselect 
                        v-model="selectKC"
                        name="nopend"
                        label="namaktr"
                        track-by="nopend" 
                        placeholder="Cari KC"
                        :options="kc"
                        :disabled="isKCDisable"
                        class="single-select filter-laporan-sppd"
                        :max-height="600"
                        @input="onKCChange">
                        <span slot="noResult">Maaf KC tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class= "mt-1" v-if="regionalUser != '99'">
                      <label>KCP</label>
                      <multiselect 
                        v-model="selectKCP"
                        name="nopend"
                        label="namaktr"
                        track-by="nopend" 
                        placeholder="Cari KCP"
                        :options="kcp"
                        :disabled="isKCPDisable"
                        class="single-select filter-laporan-sppd"
                        :max-height="600"
                        @input="selectedNIPPOSKCP(selectKCP.nopend)">
                        <span slot="noResult">Maaf KCP tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class= "mt-1" v-if="role_name != 'Pegawai'">
                      <label>NIPPOS</label>
                      <multiselect 
                        v-model="selectNIPPOS"
                        name="nippos"
                        label="nippos"
                        track-by="nippos" 
                        placeholder="Cari NIPPOS"
                        :options="nippos"
                        class="single-select filter-laporan-sppd"
                        :max-height="600"
                        @input="selectedSPPD(selectNIPPOS.nippos)">
                        <span slot="noResult">Maaf NIPPOS tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <label>No SPPD</label>
                      <v-select v-model="model.sppd_number" :options="sppd" :reduce="(item) => item.sppd_number" label="sppd_number" class="key-filter" />
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <label>Mitra Transportasi</label>
                      <multiselect 
                        v-model="selectedMitraTransportation"
                        name="id"
                        label="agen_name"
                        track-by="id" 
                        placeholder="Cari Mitra Transportasi"
                        :options="mitraTransportasi"
                        class="single-select filter-laporan-sppd"
                        :max-height="600">
                        <span slot="noResult">Maaf mitra transportasi tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <label>Mitra Akomodasi</label>
                      <multiselect 
                        v-model="selectedAccomodation"
                        name="id"
                        label="agen_name"
                        track-by="id" 
                        placeholder="Cari Mitra Akomodasi"
                        :options="mitraAkomodasi"
                        class="single-select filter-laporan-sppd"
                        :max-height="600">
                        <span slot="noResult">Maaf mitra akomodasi tidak ditemukan</span>
                      </multiselect>
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <label>Tanggal Berangkat</label>
                      <br>
                      <date-picker
                        :firstDayOfWeek="1"
                        v-model="model.departure_date"
                        name="departure_date"
                        :lang="lang"
                        :format="formats"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <label>Tanggal Kembali</label>
                      <br>
                      <date-picker
                        :firstDayOfWeek="1"
                        v-model="model.return_date"
                        name="return_date"
                        :lang="lang"
                        :format="formats"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
            <template #modal-footer>
              <div class="w-100">
                <b-button
                  variant="outline-secondary"
                  size="md"
                  class="float-right"
                  @click="reset()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="primary"
                  size="md"
                  class="float-right btn btn-primary mr-1"
                  @click="filter()"
                >
                  Submit
                </b-button>
              </div>
            </template>
            </b-modal>
          </div>
        </b-card-body>

        <b-card-body class="d-flex flex-wrap">
          <table>
            <tr>
              <th style="width: 180px;">Total Uang Harian</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllUangHArian | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Pengeluaran Rill</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllPengeluaranRiil | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Transportasi</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllTransportasi | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Akomodasi</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllAkomodasi | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Jumlah</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllJumlah | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total Jumlah</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAllPph21 | currency }}</th>
            </tr>
            <tr>
              <th style="width: 180px;">Total (Jumlah + PPH21)</th>
              <th style="width: 15px;">:</th>
              <th>{{ totalAlls | currency }}</th>
            </tr>
          </table>
          <!-- <div>
            <h5>Total Uang Harian: {{ totalAllUangHArian | currency }}</h5>
            <h5>Total Pengeluaran Rill: {{ totalAllPengeluaranRiil | currency }}</h5>
            <h5>Total Transportasi: {{ totalAllTransportasi | currency }}</h5>
            <h5>Total Akomodasi: {{ totalAllAkomodasi | currency }}</h5>
            <h5>Total Jumlah: {{ totalAllJumlah | currency }}</h5>
            <h5>Total PPH21: {{ totalAllPph21 | currency }}</h5>
            <h5>Total (Jumlah + PPH21): {{ totalAlls | currency }}</h5>
          </div> -->
        </b-card-body>


      </b-card>
    </b-col>
    <b-col v-else>
      <b-card>
        <div class="col-12 p-2 p-sm-3 mb-4 mt-3">
          <div class="w-100 text-center">
            <h2 class="mb-1">
                Tidak Memiliki Akses
            </h2>
            <p class="mb-2">
                Anda tidak memiliki akses pada halaman ini
            </p>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.width160px {
  width: 160px !important;
  background-color: "red !important";
}
</style>

<script>
import { BForm, BRow, BCol, BTable, BCard, BButton, BButtonGroup, BInputGroup, BFormInput, BInputGroupAppend, BCardBody, BFormGroup, BFormSelect, BPagination, VBPopover, BFormCheckbox, BFormRadioGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import TableFe from "@/views/table/bs-table/TableFE";
import axios from "@axios";
import Ripple from "vue-ripple-directive";
import Multiselect from 'vue-multiselect';
import { getUserData, getUserRole } from '@/auth/utils';

export default {
  name: "SppdList",
  components: {
    BForm,
    BRow,
    BCol,
    BTable,
    BCard,
    TableFe,
    BButton,
    BButtonGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardBody,
    BFormGroup,
    BFormSelect,
    vSelect,
    BPagination,
    VBPopover,
    BFormCheckbox,
    Multiselect,
    BFormRadioGroup
  },
  directives: {
    Ripple,
    "b-popover": VBPopover
  },
  data() {
    return {
      config: {
        api: "/reports",
        subdir: '/misc/sub-direktorat',
      },
      isTriger: false,
      busy: false,
      show: false,
      search: '',
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      from: 1,
      to: 10,
      sortBy: 'id',
      pageOptions: [1, 10, 25, 50, 100],
      fields: [
        "no",
        { key: "project_type", label: "Sumber Anggaran" },
        { key: "departure_date", label: "Tanggal Berangkat" },
        { key: "return_date", label: "Tanggal Kembali" },
        // { key: "day_remainder", label: "Sisa" },
        { key: "total_days", label: "Jumlah Hari" },
        { key: "name_subdirektorat", label: "Sub Direktorat" },
        { key: "sppd_number", label: "No SPPD" },
        { key: "name", label: "NIPPOS / Nama" },
        { key: "facility_type_name", label: "Jenis Fasilitas" },
        { key: "mitra_accomodation_name", label: "Mitra Akomodasi" },
        { key: "mitra_transportation_name", label: "Mitra Transportasi" },
        { key: "daily_trip_money", label: "Uang Harian" },
        { key: "total_pengeluaran_rill", label: "Pengeluaran Riil" },
        { key: "total_transportation", label: "Transportasi" },
        { key: "total_accomodation", label: "Akomodasi" },
        { key: "total_jumlah", label: "Jumlah" },
        { key: "pph21", label: "Pph21" },
        { key: "total", label: "Jumlah + PPH21" },
        // { key: "period", label: "Periode" },
      ],
      fieldsRegional: [
        "no",
        { key: "project_type", label: "Sumber Anggaran" },
        { key: "departure_date", label: "Tanggal Berangkat" },
        { key: "return_date", label: "Tanggal Kembali" },
        // { key: "day_remainder", label: "Sisa" },
        { key: "total_days", label: "Jumlah Hari" },
        { key: "name_regional", label: "Regional" },
        { key: "name_kcu", label: "KCU" },
        { key: "name_kc", label: "KC" },
        { key: "name_kcp", label: "KCP" },
        { key: "sppd_number", label: "No SPPD" },
        { key: "name", label: "NIPPOS / Nama" },
        { key: "facility_name", label: "Jenis Fasilitas" },
        { key: "daily_trip_money", label: "Uang Harian" },
        { key: "mitra_accomodation_name", label: "Mitra Akomodasi" },
        { key: "mitra_transportation_name", label: "Mitra Transportasi" },
        { key: "total_pengeluaran_rill", label: "Pengeluaran Riil" },
        { key: "total_transportation", label: "Transportasi" },
        { key: "total_accomodation", label: "Akomodasi" },
        { key: "total_jumlah", label: "Jumlah" },
        { key: "pph21", label: "Pph21" },
        { key: "total", label: "Jumlah + PPH21" },        
        // { key: "period", label: "Periode" },
      ],
      totalUangHArian: 0,
      totalPengeluaranRiil: 0,
      totalTransportasi: 0,
      totalAkomodasi: 0,
      totalJumlah: 0,
      totalPph21: 0,
      totalAll: 0,
      totalAllUangHArian: 0,
      totalAllPengeluaranRiil: 0,
      totalAllTransportasi: 0,
      totalAllAkomodasi: 0,
      totalAllJumlah: 0,
      totalAllPph21: 0,
      totalAlls: 0,
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
      userData: getUserData(),
      userDataRegional: getUserData().regional,
      report: [],
      regional: [],
      upt: [],
      kcu: [],
      kc: [],
      kcp: [],
      uptSppd: [],
      nippos: [],
      sppd: [],
      sppdNIP: [],
      mitraTransportasi: [],
      mitraAkomodasi: [],
      // selectedProject: { text: 'Non Project', value: 'nonproject' },
      selectedProject: null,
      selectProjectOption: [
        { text: 'Cari Sumber Anggaran', value: ''},
        { text: 'Project', value: 'project'},
        { text: 'Non Project', value: 'nonproject'},
      ],
      subdirData: [],
      subdirLists: [],
      isSubdirDisabled: false,
      isRegionalDisabled: false,
      isKCDisable: false,
      isKCUDisable: false,
      isKCPDisable: false,
      key_filter: [
        { key: "nippos", label: "NIPPOS" },
        { key: "sppd_number", label: "No SPPD" },
        { key: "name", label: "Nama" },
        { key: "departure_date", label: "Tanggal Berangkat" },
        { key: "return_date", label: "Tanggal Kembali" },
      ],
      model: {
        nippos : '',
        sppd_number: '',
        name: '',
        departure_date: '',
        return_date: '',
        regional: '',
        company: '',
        mitra_accomodation: '',
        mitra_transportation: '',
        code_subdirektorat: '',
        name_subdirektorat: '',
        project_type: '',
      },
      selectRegional: [],
      selectedAccomodation: "",
      selectedMitraTransportation: "",
      selectUPT: '',
      selectKCU: '',
      selectKC: '',
      selectKCP: '',
      // selectKCU: {
      //   nopend: '',
      //   namaktr: "SEMUA KCU",
      // },
      // selectKC: {
      //   nopend: '',
      //   namaktr: "SEMUA KC",
      // },
      // selectKCP: {
      //   nopend: '',
      //   namaktr: "SEMUA KCP",
      // },
      selectNIPPOS: "",
      regionalUser: getUserData().regional,
      role_name: getUserRole(),
      scope: getUserData().scope,
      relation: 'KCU',
      filterRelation: [
        'PUSAT',
         'KCU',
         'KC',
         'KCP',
         'AREA'
      ],
      nextTodoId: 2,
      formats: "DD/MM/YYYY",
      lang: {
        days: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Mei",
          "Jun",
          "Jul",
          "Agu",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days",
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range",
        },
        busy: false,
      },
    };
  },
  watch: {
    search: function () {
      this.isTriger = true;
      this.$refs.tableFe.refresh();
      // this.getTotalAnggaran();
    },
  },
  mounted() {
    let _ = this;
    if (_.$route.params) {
      if (_.$route.params.event) {
        _.makeToast(
          _.$route.params.event,
          _.$route.params.title,
          _.$route.params.text
        );
      }
    }
    //_.getReports()
    _.getSubdirList()
    _.getRegional()
    _.getNIPPOS()
    _.getMitraAkomodasi()
    _.getMitraTransportasi()
    if (_.role_name != 'Admin Nasional') {
      // _.getUPT()
    }
    if(_.role_name == 'Pegawai') {
      _.selectNIPPOS.nippos = _.userData.nippos;
      _.selectedSPPD(_.userData.nippos)
    }
  },
  computed: {
  },
  methods: {
    disabledDate(date) {
      return new Date() < date;
    },
    selectedRelation(data) {
      let _ = this
      _.relation = data
      if (_.role_name == 'Admin Nasional') {
        localStorage.setItem('relation', data)
        _.selectRegional = []
        _.selectUPT = ''
        _.selectKCU = ''
        _.selectKC = ''
        _.selectKCP = ''
        _.selectNIPPOS = ''
        _.selectedAccomodation = ''
        _.selectedMitraTransportation = ''
        _.model.regional = ''
        _.model.company = ''
        _.model.nippos = ''
        _.model.sppd_number = ''
        _.model.name = ''
        _.model.departure_date = ''
        _.model.return_date = ''
      } else {
        _.selectUPT = ''
        _.selectKCU = '',
        _.selectKC = ''
        _.selectKCP = ''
        _.selectNIPPOS = ''
        _.selectedAccomodation = ''
        _.selectedMitraTransportation = ''
        _.model.regional = ''
        _.model.company = ''
        _.model.nippos = ''
        _.model.sppd_number = ''
        _.model.name = ''
        _.model.departure_date = ''
        _.model.return_date = ''
        // _.getUPT()
      }
    },
    handleSearch() {
      console.log("Searching for: ", this.search);
      this.isTriger = true;
      this.$refs.tableFe.refresh();
      // this.getTotalAnggaran();
    },
    getItems(ctx, callback) {
      const _ = this
      _.busy = true;
      // console.log(_.selectNIPPOS.nippos);
      // console.log(_.selectNIPPOS);

      let endpoint = `${_.config.api}?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
      if (_.search != "") {
        endpoint += `&key=${_.search}`
      }
      if (_.selectedProject && _.selectedProject.value) {
        endpoint += `&project_type=${_.selectedProject.value}`;
      }
      if (_.selectRegional.idwilayah != undefined) {
        endpoint += `&regional=${_.selectRegional.idwilayah}|${_.selectRegional.nmwilayah}`
      }
      if (_.model.code_subdirektorat != '') { 
        endpoint += `&subdir=${_.model.code_subdirektorat}|${_.model.name_subdirektorat}`
      }
      if (_.selectNIPPOS.nippos) {
        endpoint += `&nippos=${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`
      }
      if (_.model.sppd_number) {
        endpoint += `&sppd_number=${_.model.sppd_number}`
      }
      if (_.model.name) {
        endpoint += `&name=${_.model.name}`
      }
      if (_.selectedMitraTransportation.id) {
        endpoint += `&mitra_transportation=${_.selectedMitraTransportation.id}|${_.selectedMitraTransportation.agen_name}`
      }
      if (_.selectedAccomodation.id) {
        endpoint += `&mitra_accomodation=${_.selectedAccomodation.id}|${_.selectedAccomodation.agen_name}`
      }
      if (_.model.departure_date) {
        endpoint += `&departure_date=${_.model.departure_date}`
      }
      if (_.model.return_date) {
        endpoint += `&return_date=${_.model.return_date}`
      }
      if (_.selectKCU && _.selectKCU.nopend) {
        // endpoint += `&nopend=${_.selectKCU.nopend}`
        endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
      }
      // if (_.selectKCU == []) {
      //   endpoint += `&nopend=[]`
      // }
      if (_.selectKC && _.selectKC.nopend) {
        endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
      }
      if(_.selectKCP && _.selectKCP.nopend) {
        endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
      }
      // if (_.selectKC == []) {
      //   endpoint += `&nopend=[]`
      // }
      // console.log(endpoint);
      
      if (_.role_name != 'Admin Nasional') {
        axios
          .get(encodeURI(endpoint))
          .then(resp => {
            const consume = resp.data.data
            _.data = resp.data.data
            _.perPage = consume.per_page ?? 10
            _.currentPage = consume.current_page ?? 1
            _.totalRows = consume.total
            _.from = consume.from ?? 0
            _.to = consume.to ?? 0

            let totalUangHArian = 0
            let totalPengeluaranRiil = 0
            let totalTransportasi = 0
            let totalAkomodasi = 0
            let totalJumlah = 0
            let totalPPH21 = 0
            let totalAll = 0
            if (consume.data && Array.isArray(consume.data)) {
              consume.data.forEach(item => {
                totalUangHArian += Number(item.daily_trip_money) || 0
                totalPengeluaranRiil += Number(item.total_pengeluaran_rill) || 0
                totalTransportasi += Number(item.total_transportation) || 0
                totalAkomodasi += Number(item.total_accomodation) || 0
                totalJumlah += Number(item.total) || 0
                totalPPH21 += Number(item.pph21) || 0
                totalAll += Number(item.total + item.pph21) || 0
              })
            }
            _.totalUangHArian = totalUangHArian
            _.totalPengeluaranRiil = totalPengeluaranRiil
            _.totalTransportasi = totalTransportasi
            _.totalAkomodasi = totalAkomodasi
            _.totalJumlah = totalJumlah
            _.totalPPH21 = totalPPH21
            _.totalAll = totalAll

            // callback(consume.data || [])
            callback([
              ...(consume.data || []),
              { isTotal: true }
            ])
          })
          .catch(error => {
            console.error(error)

            var message = "";
            if(typeof error.response.data.message === 'object'){
              message = error.response.data.message.errors[0].msg
            } else {
              message = error.response.data.message
            }
            this.makeToast('danger', "Terjadi Kesalahan", message)
          })
          .finally(() => {
            _.busy = false;
          });
      } else {
        if (_.model.code_subdirektorat || _.selectedProject || _.selectNIPPOS.nippos || _.model.sppd_number || _.model.name || _.selectedMitraTransportation.id  || _.selectedAccomodation.id || _.model.departure_date || _.model.return_date || _.selectRegional.idwilayah || _.selectUPT.namaktr || _.search) {
          axios
            .get(encodeURI(endpoint))
            .then(resp => {
              const consume = resp.data.data
              _.data = resp.data.data
              _.perPage = consume.per_page ?? 10
              _.currentPage = consume.current_page ?? 1
              _.totalRows = consume.total
              _.from = consume.from ?? 0
              _.to = consume.to ?? 0
              // callback(consume.data || [])

              let totalUangHArian = 0
              let totalPengeluaranRiil = 0
              let totalTransportasi = 0
              let totalAkomodasi = 0
              let totalJumlah = 0
              let totalPPH21 = 0
              let totalAll = 0
              if (consume.data && Array.isArray(consume.data)) {
                consume.data.forEach(item => {
                  totalUangHArian += Number(item.daily_trip_money) || 0
                  totalPengeluaranRiil += Number(item.total_pengeluaran_rill) || 0
                  totalTransportasi += Number(item.total_transportation) || 0
                  totalAkomodasi += Number(item.total_accomodation) || 0
                  totalJumlah += Number(item.total) || 0
                  totalPPH21 += Number(item.pph21) || 0
                  totalAll += Number(item.total + item.pph21) || 0
                })
              }
              _.totalUangHArian = totalUangHArian
              _.totalPengeluaranRiil = totalPengeluaranRiil
              _.totalTransportasi = totalTransportasi
              _.totalAkomodasi = totalAkomodasi
              _.totalJumlah = totalJumlah
              _.totalPPH21 = totalPPH21
              _.totalAll = totalAll

              // callback(consume.data || [])
              callback([
                ...(consume.data || []),
                { isTotal: true }
              ])
            })
            .catch(error => {
              console.error(error)

              var message = "";
              if(typeof error.response.data.message === 'object'){
                message = error.response.data.message.errors[0].msg
              } else {
                message = error.response.data.message
              }
              this.makeToast('danger', "Terjadi Kesalahan", message)
            })
            .finally(() => {
              _.busy = false;
            });
        } else {
          let endpoint_null = `${_.config.api}?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
          axios
            .get(encodeURI(endpoint_null))
            .then(resp => {
              const consume = resp.data.data
              _.data = resp.data.data
              _.perPage = consume.per_page ?? 10
              _.currentPage = consume.current_page ?? 1
              _.totalRows = consume.total ?? 0
              _.from = consume.from ?? 0
              _.to = consume.to ?? 0
              // callback(consume.data || [])

              let totalUangHArian = 0
              let totalPengeluaranRiil = 0
              let totalTransportasi = 0
              let totalAkomodasi = 0
              let totalJumlah = 0
              let totalPPH21 = 0
              let totalAll = 0
              if (consume.data && Array.isArray(consume.data)) {
                consume.data.forEach(item => {
                  totalUangHArian += Number(item.daily_trip_money) || 0
                  totalPengeluaranRiil += Number(item.total_pengeluaran_rill) || 0
                  totalTransportasi += Number(item.total_transportation) || 0
                  totalAkomodasi += Number(item.total_accomodation) || 0
                  totalJumlah += Number(item.total) || 0
                  totalPPH21 += Number(item.pph21) || 0
                  totalAll += Number(item.total + item.pph21) || 0
                })
              }
              _.totalUangHArian = totalUangHArian
              _.totalPengeluaranRiil = totalPengeluaranRiil
              _.totalTransportasi = totalTransportasi
              _.totalAkomodasi = totalAkomodasi
              _.totalJumlah = totalJumlah
              _.totalPPH21 = totalPPH21
              _.totalAll = totalAll

              // callback(consume.data || [])
              callback([
                ...(consume.data || []),
                { isTotal: true }
              ])
            })
            .catch(error => {
              console.error(error)

              var message = "";
              if(typeof error.response.data.message === 'object'){
                message = error.response.data.message.errors[0].msg
              } else {
                message = error.response.data.message
              }
              this.makeToast('danger', "Terjadi Kesalahan", message)
            })
            .finally(() => {
              _.busy = false;
            });
        }
      }

      this.getTotalAnggaran();

    },
    changePerPage() {
      const _ = this
      _.isTriger = true;
      _.$refs.tableFe.refresh()
    },
    changeCurrentPage(currentPage) {
      let _ = this;
      _.currentPage = currentPage;
    },
    getTotalAnggaran() {
      const _ = this

      let endpoint = `${_.config.api}/summary?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
      if (_.search != "") {
        endpoint += `&key=${_.search}`
      }
      if (_.selectedProject && _.selectedProject.value) {
        endpoint += `&project_type=${_.selectedProject.value}`;
      }
      if (_.selectRegional.idwilayah != undefined) {
        endpoint += `&regional=${_.selectRegional.idwilayah}|${_.selectRegional.nmwilayah}`
      }
      if (_.model.code_subdirektorat != '') { 
        endpoint += `&subdir=${_.model.code_subdirektorat}|${_.model.name_subdirektorat}`
      }
      if (_.selectNIPPOS.nippos) {
        endpoint += `&nippos=${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`
      }
      if (_.model.sppd_number) {
        endpoint += `&sppd_number=${_.model.sppd_number}`
      }
      if (_.model.name) {
        endpoint += `&name=${_.model.name}`
      }
      if (_.selectedMitraTransportation.id) {
        endpoint += `&mitra_transportation=${_.selectedMitraTransportation.id}|${_.selectedMitraTransportation.agen_name}`
      }
      if (_.selectedAccomodation.id) {
        endpoint += `&mitra_accomodation=${_.selectedAccomodation.id}|${_.selectedAccomodation.agen_name}`
      }
      if (_.model.departure_date) {
        endpoint += `&departure_date=${_.model.departure_date}`
      }
      if (_.model.return_date) {
        endpoint += `&return_date=${_.model.return_date}`
      }
      if (_.selectKCU && _.selectKCU.nopend) {
        // endpoint += `&nopend=${_.selectKCU.nopend}`
        endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
      }
      // if (_.selectKCU == []) {
      //   endpoint += `&nopend=[]`
      // }
      if (_.selectKC && _.selectKC.nopend) {
        endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
      }
      if(_.selectKCP && _.selectKCP.nopend) {
        endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
      }

      // console.log(endpoint);

      axios
        .get(encodeURI(endpoint))
        .then(resp => {
          // console.log(resp.data.data);
          const consume = resp.data.data
          console.log(consume);
          
          
          _.totalAllUangHArian = consume.total_daily_money || 0
          _.totalAllPengeluaranRiil = consume.total_pengeluaran_rill || 0
          _.totalAllTransportasi = consume.total_transportation || 0
          _.totalAllAkomodasi = consume.total_accomodation || 0
          _.totalAllJumlah = consume.total_all || 0
          _.totalAllPph21 = consume.total_pph21 || 0
          _.totalAlls = consume.total_all_pph21 || 0
        })
        .catch(error => {
          console.error(error)
          _.totalAnggaran = 0;

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
    },
    makeToast(variant = null, title = "Title here...", text = "Text here...") {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      });
    },
    exportData() {
      let _ = this;
      if(_.totalRows > 0){
        let today = new Date();
        let dateNow = today.toLocaleDateString('en-GB', {
          day: 'numeric', month: 'numeric', year: 'numeric'
        }).replace(/[^\d,.-]/g,'-');     
        let timeNow = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds(); 
        // let endpoint = `${_.config.api + "/export"}?isTriger=${_.isTriger}&key=${_.search}`
        // let endpoint = `${_.config.api + "/export"}`

        // if (_.search != "") {
        //   endpoint += `&key=${_.search}`
        // }
        // if (_.search != "") {
        //   endpoint += `&key=${_.search}`
        // }
        // if (_.selectedProject && _.selectedProject.value) {
        //   endpoint += `&project_type=${_.selectedProject.value}`;
        // }
        // if (_.selectRegional.idwilayah != undefined) {
        //   endpoint += `&regional=${_.selectRegional.idwilayah}|${_.selectRegional.nmwilayah}`
        // }
        // if (_.model.code_subdirektorat != '') { 
        //   endpoint += `&subdir=${_.model.code_subdirektorat}|${_.model.name_subdirektorat}`
        // }
        // if (_.selectNIPPOS.nippos) {
        //   endpoint += `&nippos=${_.selectNIPPOS.nippos}|${_.selectNIPPOS.name}`
        // }
        // if (_.model.sppd_number) {
        //   endpoint += `&sppd_number=${_.model.sppd_number}`
        // }
        // if (_.model.name) {
        //   endpoint += `&name=${_.model.name}`
        // }
        // if (_.selectedMitraTransportation.id) {
        //   endpoint += `&mitra_transportation=${_.selectedMitraTransportation.id}|${_.selectedMitraTransportation.agen_name}`
        // }
        // if (_.selectedAccomodation.id) {
        //   endpoint += `&mitra_accomodation=${_.selectedAccomodation.id}|${_.selectedAccomodation.agen_name}`
        // }
        // if (_.model.departure_date) {
        //   endpoint += `&departure_date=${_.model.departure_date}`
        // }
        // if (_.model.return_date) {
        //   endpoint += `&return_date=${_.model.return_date}`
        // }
        // if (_.selectKCU.nopend) {
        //   // endpoint += `&nopend=${_.selectKCU.nopend}`
        //   endpoint += `&nopend_kcu=${_.selectKCU.nopend}|${_.selectKCU.namaktr}`
        // }
        // // if (_.selectKCU == []) {
        // //   endpoint += `&nopend=[]`
        // // }
        // if (_.selectKC.nopend) {
        //   endpoint += `&nopend_kc=${_.selectKC.nopend}|${_.selectKC.namaktr}`
        // }
        // if(_.selectKCP.nopend) {
        //   endpoint += `&nopend_kcp=${_.selectKCP.nopend}|${_.selectKCP.namaktr}`
        // }
        const params = new URLSearchParams();

        params.append('isTriger', _.isTriger);
        params.append('key', _.search || '');

        if (_.selectedProject && _.selectedProject.value) {
          params.append('project_type', _.selectedProject.value);
        }
        if (_.selectRegional.idwilayah != undefined) {
          params.append('regional', `${_.selectRegional.idwilayah}|${_.selectRegional.nmwilayah}`);
        }
        if (_.model.code_subdirektorat != '') { 
          params.append('subdir', `${_.model.code_subdirektorat}|${_.model.name_subdirektorat}`);
        }

        if (_.selectNIPPOS.nippos) {
          params.append('nippos', `${_.selectNIPPOS.nippos}|${_.selectNIPPOS.nama}`);
        }

        if (_.model.sppd_number) {
          params.append('sppd_number', _.model.sppd_number);
        }

        if (_.model.name) {
          params.append('name', _.model.name);
        }

        if (_.selectedMitraTransportation.id) {
          params.append('mitra_transportation', `${_.selectedMitraTransportation.id}|${_.selectedMitraTransportation.agen_name}`);
        }
        if (_.selectedAccomodation.id) {
          params.append('mitra_accomodation', `${_.selectedAccomodation.id}|${_.selectedAccomodation.agen_name}`);
        }

        if (_.model.departure_date) {
          params.append('departure_date', _.model.departure_date);
        }

        if (_.model.return_date) {
          params.append('return_date', _.model.return_date);
        }

        if (_.selectKCU?.nopend) {
          params.append('nopend_kcu', `${_.selectKCU.nopend}|${_.selectKCU.namaktr}`);
        }

        if (_.selectKC?.nopend) {
          params.append('nopend_kc', `${_.selectKC.nopend}|${_.selectKC.namaktr}`);
        }

        if (_.selectKCP?.nopend) {
          params.append('nopend_kcp', `${_.selectKCP.nopend}|${_.selectKCP.namaktr}`);
        }

        const endpoint = `${_.config.api}/export?isTriger=${_.isTriger}&${params.toString()}`;

        axios({
            url: endpoint,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'laporan-'+dateNow+'-'+timeNow+'.xls');
            document.body.appendChild(fileLink);
            
            fileLink.click();
        });
      }
    },
    getReports(){
        let _ = this
        let uri = "/misc/report"
        axios.get(uri+ '?company=' + _.userData.nopend).then(resp => {
            _.report = resp.data.data
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
    },
    changeSubdir(){
      this.selectRegional = []
      this.selectKCU = '',
      this.selectKC = '',
      this.selectKCP = '',
      this.selectNIPPOS = '',
      this.isSubdirDisabled = false;
      this.isRegionalDisabled = true;
      this.isKCDisable = true;
      this.isKCUDisable = true;
      this.isKCPDisable = true;

      // console.log(this.subdirData.kodebagian_child);
      this.model.code_subdirektorat = this.subdirData.kodebagian_child;
      this.model.name_subdirektorat = this.subdirData.namabagian_child;
      
      if (this.subdirData.kodebagian_child == '') {
        this.isRegionalDisabled = false;
        this.isKCDisable = false;
        this.isKCUDisable = false;
        this.isKCPDisable = false;
      }
    },
    getSubdirList() {
      axios.get(this.config.subdir).then(response => {
        this.subdirLists = response.data.data
        this.subdirLists.unshift({
                kodebagian_child: "",
                namabagian_child: "Cari Sub Direktorat",
            })
      })
      .catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getRegional(){
      let _ = this
      let uri = "/misc/regionals"
      axios.get(uri).then(resp => {
        _.regional = resp.data.data.data
        _.regional.unshift({
          idwilayah: "",
          nmwilayah: "Pilih Regional",
        })

        _.selectRegional = _.regional.filter((item) => {
          return item.idwilayah == _.regionalUser
        })[0] || null;

        _.isRegionalDisabled = true;
        console.log("regionalUser", _.isRegionalDisabled);
        if(_.selectRegional.idwilayah != '99'){
          _.selectedUPT(_.selectRegional.idwilayah, _.selectRegional.nopen);
        }
        // _.regional.unshift({
        //       idwilayah: ["99", "03", "02", "01"],
        //       nmwilayah: "SEMUA REGIONAL",
        //   })
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    selectedUPT(id, kcu_id){
        let _ = this
        _.subdirData = []
        _.isSubdirDisabled = true;
        _.isRegionalDisabled = false;
        
        if(id == undefined || id == null || id == '') {
          console.log("wew");
        } else {
          console.log("wew else");
        }
        
        console.log("idWilayah "+id);
        
        if (id == '') {
          _.isSubdirDisabled = false;
        } else if(id == '99') {
          _.isKCDisable = true;
          _.isKCUDisable = true; 
          _.isKCPDisable = true;
        } else {
          _.isKCDisable = false;
          _.isKCUDisable = false;
          _.isKCPDisable = false;
        } 
        
        if(id != '99' && id != ''){
          _.selectedKCU(kcu_id);
          // Load KC default untuk regional ini
          _.selectedKC('0');
          // Load KCP default untuk regional ini
          _.selectedKCP('0');
        }
    },
    selectedKCU(id){
      if(id != "" && id != "0"){
        let _ = this;
        // let uri = "/misc/companies/level"
        let uri = "/misc/companies/kcu/"+id;
        // axios.get(uri+ '?region=' + id + '&relation=KCU').then(resp => {
        axios.get(uri).then(resp => {
          var data = resp.data.data.data;
          // if(data.length === 0){
          //   data.where((item) => {
          //     return item.idwilayah !== "99"
          //   });
          //   console.log(data);
            
          //   // _.kantorList = resp.data.data
          // }
            _.kcu = data
            _.kcu.unshift({
                nopend: '0',
                namaktr: "SEMUA KCU",
            })
            _.selectKCU= null
            // _.selectKCU= {
            //   nopend: '',
            //   namaktr: "SEMUA KCU",
            // }
            // _.selectKCU.nopend = ''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedKC(id){
      let _ = this;
      
      if(id != "" && id != "0"){
        // Jika dipilih KCU spesifik, ambil KC dari KCU tersebut
        let uri = "/misc/companies/kc/"+id
        axios.get(uri).then(resp => {
            _.kc = resp.data.data.data
            _.kc.unshift({
                nopend: '0',
                namaktr: "SEMUA KC",
            })
            _.selectKC= ''
        }).catch(error => {
          console.error(error)
          _.kc = [];

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      } else if(id == "0" && _.selectRegional && _.selectRegional.idwilayah && _.selectRegional.idwilayah != "" && _.selectRegional.idwilayah != "99") {
        // Jika dipilih SEMUA KCU, ambil semua KC dari regional yang dipilih
        let uri = "/misc/companies/level"
        axios.get(uri+ '?region=' + _.selectRegional.idwilayah + '&relation=KC').then(resp => {
            if(resp.data.data && Array.isArray(resp.data.data)) {
              _.kc = [...resp.data.data]
              _.kc.unshift({
                  nopend: '0',
                  namaktr: "SEMUA KC",
              })
              _.selectKC= ''
              console.log('KC loaded for SEMUA KCU, total items:', _.kc.length, 'First few items:', _.kc.slice(0, 3))
            } else {
              console.error('Invalid KC data received:', resp.data.data)
              _.kc = [{
                  nopend: '0',
                  namaktr: "SEMUA KC",
              }]
            }
        }).catch(error => {
          console.error('Error loading KC:', error)
          _.kc = [];

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedKCP(id){
      let _ = this;
      
      if(id != "" && id != "0"){
        // Jika dipilih KC spesifik, ambil KCP dari KC tersebut
        let uri = "/misc/companies/kcp/" + id;
        axios.get(uri).then(resp => {
            _.kcp = resp.data.data.data ?? []
            _.kcp.unshift({
                nopend: '0',
                namaktr: "SEMUA KCP",
            })
            _.selectKCP= ''
            _.selectedNIPPOSKCP(id);
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      } else if(id == "0" && _.selectRegional && _.selectRegional.idwilayah && _.selectRegional.idwilayah != "" && _.selectRegional.idwilayah != "99") {
        // Jika dipilih SEMUA KC, ambil semua KCP dari regional yang dipilih
        let uri = "/misc/companies/level"
        axios.get(uri+ '?region=' + _.selectRegional.idwilayah + '&relation=KCP').then(resp => {
            _.kcp = resp.data.data ?? []
            _.kcp.unshift({
                nopend: '0',
                namaktr: "SEMUA KCP",
            })
            _.selectKCP= ''
        }).catch(error => {
          console.error(error)
          _.kcp = [];

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedNIPPOSKCU(id, kcuId){
      if(id != ""){
        let _ = this
        
        // Jika dipilih KCU spesifik, ambil NIPPOS dari KCU tersebut
        if(id != "0") {
          let uri = "/misc/employees"
          axios.get(uri+ '?company=' + id +"&kcu_id=" + kcuId).then(resp => {
              _.nippos = resp.data.data
              _.selectNIPPOS=''
          }).catch(error => {
            console.error(error)

            var message = "";
            if(typeof error.response.data.message === 'object'){
              message = error.response.data.message.errors[0].msg
            } else {
              message = error.response.data.message
            }
            this.makeToast('danger', "Terjadi Kesalahan", message)
          });
        } else {
          // Jika dipilih SEMUA KCU, ambil semua NIPPOS dari regional
          if(_.selectRegional && _.selectRegional.idwilayah && _.selectRegional.idwilayah != "" && _.selectRegional.idwilayah != "99") {
            let uri = "/misc/employees"
            axios.get(uri+ '?company=' + _.selectRegional.idwilayah).then(resp => {
                _.nippos = resp.data.data
                _.selectNIPPOS=''
            }).catch(error => {
              console.error(error)

              var message = "";
              if(typeof error.response.data.message === 'object'){
                message = error.response.data.message.errors[0].msg
              } else {
                message = error.response.data.message
              }
              this.makeToast('danger', "Terjadi Kesalahan", message)
            });
          }
        }

        // Tidak perlu memanggil selectedKC dan selectedKCP lagi di sini 
        // karena sudah dipanggil di onKCUChange
      }
    },
    selectedNIPPOS(id){
      if(id != ""){
        let _ = this
        _.selectKCU = ''
        let uri = "/misc/employees"
        axios.get(uri+ '?company=' + id).then(resp => {
          _.nippos = resp.data.data
          _.selectNIPPOS=null
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedNIPPOSKCP(id){
      if(id != ""){
        let _ = this
        // _.selectKCU = ''
        let uri = "/misc/employees"
        axios.get(uri+ '?company=' + id).then(resp => {
          _.nippos = resp.data.data
          _.selectNIPPOS=''
        }).catch(error => {
          console.error(error)

          var message = "";
          if(typeof error.response.data.message === 'object'){
            message = error.response.data.message.errors[0].msg
          } else {
            message = error.response.data.message
          }
          this.makeToast('danger', "Terjadi Kesalahan", message)
        });
      }
    },
    selectedSPPD(id){
      let _ = this
      let uri = "/misc/sppds"
      axios.get(uri+ '?nippos=' + id).then(resp => {
          _.sppd = resp.data.data
          _.model.sppd_number=''
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getUPT(){
      let _ = this
      let uri = "/misc/companies/level"
      axios.get(uri+ '?region=' + _.userDataRegional + '&relation=KCU').then(resp => {
        console.log(resp.data.data);
        
          _.kcu = resp.data.data
          _.kcu.unshift({
              nopend: [],
              namaktr: "SEMUA KCU",
          })
          _.selectKCU = null;
          // _.selectKCU.nopend = ''
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
      axios.get(uri+ '?region=' + _.userDataRegional + '&relation=KC').then(resp => {
          _.kc = resp.data.data
          _.kc.unshift({
              nopend: [],
              namaktr: "SEMUA KC",
          })
          _.selectKC= ''
          _.selectKC.nopend = ''
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getNIPPOS(){
      let _ = this
      let uri = "/misc/employees"
      axios.get(uri+ '?company=' + _.userData.nopend).then(resp => {
          _.nippos = resp.data.data
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getSPPD(){
      let _ = this
      let uri = "/misc/sppds"
      axios.get(uri+ '?nippos=' + _.userData.nippos).then(resp => {
          _.sppdNIP = resp.data.data
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getMitraTransportasi(){
      let _ = this
      let uri = "/misc/mitras"
      axios.get(uri).then(resp => {
          _.mitraTransportasi = resp.data.data
          _.mitraTransportasi.unshift({
              id: '0',
              // agen_name: "Semua Mitra Transportasi",
              agen_name: "-",
          })
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getMitraAkomodasi(){
      let _ = this
      let uri = "/misc/mitras"
      axios.get(uri).then(resp => {
          _.mitraAkomodasi = resp.data.data
          _.mitraAkomodasi.unshift({
              id: '0',
              // agen_name: "Semua Mitra Akomodasi",
              agen_name: "-",
          })
      }).catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
    },
    onKCUChange() {
      let _ = this;
      if(_.selectKCU && _.selectKCU.nopend) {
        // Reset KC dan KCP ketika KCU berubah
        _.selectKC = '';
        _.selectKCP = '';
        
        if(_.selectKCU.nopend === '0') {
          // Jika pilih SEMUA KCU, load semua KC dari regional
          _.selectedKC('0');
          // Delay KCP loading to avoid race condition
          setTimeout(() => {
            _.selectedKCP('0');
          }, 100);
        } else {
          // Jika pilih KCU spesifik, load KC dari KCU tersebut
          _.selectedKC(_.selectKCU.nopend);
          setTimeout(() => {
            _.selectedKCP(_.selectKCU.nopend);
          }, 100);
        }
        
        _.selectedNIPPOSKCU(_.selectKCU.nopend, _.selectKCU.kcu);
      }
    },
    onKCChange() {
      let _ = this;
      if(_.selectKC && _.selectKC.nopend) {
        // Reset KCP ketika KC berubah
        _.selectKCP = '';
        _.selectedKCP(_.selectKC.nopend);
      }
    },
    filter() {
      if (this.selectRegional == null) {
        this.selectRegional = ''
      }
      if (this.selectKCU == null) {
        this.selectKCU = ''
        // this.selectKCU = {
        //   nopend: '',
        //   namaktr: "SEMUA KCU",
        // }
      }
      if (this.selectKC == null) {
        this.selectKC = ''
        // this.selectKC = {
        //   nopend: '',
        //   namaktr: "SEMUA KC",
        // }
      }
      if (this.selectNIPPOS == null) {
        this.selectNIPPOS = ''
      }
      // if (this.model.regional == null) {
      //   this.model.regional = ''
      // }
      if (this.model.company == null) {
        this.model.company = ''
      }
      if (this.model.nippos == null) {
        this.model.nippos = ''
      }
      if (this.model.sppd_number == null) {
        this.model.sppd_number = ''
      }
      if (this.selectedAccomodation == null) {
        this.selectedAccomodation = ''
      }
      if (this.selectedMitraTransportation == null) {
        this.selectedMitraTransportation = ''
      }
      if (this.code_subdirektorat == null) {
        this.code_subdirektorat = ''
        this.name_subdirektorat = ''
      }
      if (this.selectedProject == null) {
        this.selectedProject = ''
      }
      this.show = false
      
      this.isTriger = true;
      this.$refs.tableFe.refresh()
      // this.getTotalAnggaran();
    },
    reset() {
      // this.selectRegional = '',
      this.selectUPT = '',
      this.selectKCU = '',
      this.selectKC = '',
      this.selectKCP = '',
      // this.selectKCU = {
      //   nopend: '',
      //   namaktr: "SEMUA KCU",
      // },
      // this.selectKC = {
      //   nopend: '',
      //   namaktr: "SEMUA KC",
      // },
      // this.selectKCP = {
      //   nopend: '',
      //   namaktr: "SEMUA KCP",
      // },
      this.selectNIPPOS = '',
      this.model.regional = '',
      this.model.company = '',
      this.model.nippos = '',
      this.model.sppd_number = '',
      this.model.name = '',
      this.model.departure_date = '',
      this.model.return_date = '',
      this.selectedAccomodation = '',
      this.selectedMitraTransportation = '',
      this.selectedMitraTransportation = '',
      this.selectedMitraTransportation = '',
      this.model.code_subdirektorat = '',
      this.model.name_subdirektorat = '',
      this.subdirData = null,
      this.show = false,
      this.isTriger = false,
      this.selectedProject = null,
      this.isSubdirDisabled = false,
      this.isRegionalDisabled = false,
      this.isKCDisable = false,
      this.isKCUDisable = false,
      this.isKCPDisable = false;

      this.$refs.tableFe.refresh();
      this.getNIPPOS();
      // this.getTotalAnggaran();
    },
  },
};
</script>

<style>
.b-popover{
  font-size: 10px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>